export default "__VITE_PUBLIC_ASSET__130a8627__"